export const PRIMARY_COLOR = '#62BC9F';
export const CARD_BORDER_COLOR = '#e9ecef';
export const DARK_COLOR = '#273444';
export const WARNING_COLOR = '#FF7070';
export const GRAY_400 = '#E0E6ED';
export const PLACEHOLDER = '#aabacd';
export const BORDER_RADIUS = '15px';
export const PASTEL_RED = '#BC6372';
export const MAX_Z_INDEX = 1000;
export const HEADER_MENU_Z_INDEX = MAX_Z_INDEX - 20;